import Vue from 'vue';

export default {
  
  async fetchProgressAnalysisByDprId({ commit }, dprId) {
    return Vue.axios.get(Vue.$url("vessel-progress-analysis/" + dprId))
      .then((rsp) => commit("SET_PROGRESSANALYSIS", rsp.data))

  }

}